<template>
  <div>
    <b-img :src="asset.URL" blank-color="#777"></b-img>
  </div>
</template>

<script>
export default {
  props: ["asset"]
};
</script>

<style>
</style>